export default {
    HOTELS_CLICK_HOTEL_MARKER: 'hotels-marker-click',
    HOTELS_TRIGGER_HOTEL_FILTERS: 'trigger-hotel-filters',
    HOTELS_CLEAR_HOTEL_FILTERS: 'clear-hotel-filters',
    HOTELS_APPLY_FILTERS: 'apply-hotel-filters',
    HOTELS_UPDATE_MAP_MARKERS: 'update-map-marker',
    HOTELS_TRIGGER_HOTELS_SORTING: 'trigger-hotels-sorting',
    HOTELS_TRIGGER_MAP_VISIBILITY: 'trigger-map-visibility',
};



// WEBPACK FOOTER //
// ./src/app/modules/hotels/config/hotel-events.js